export class FormatHelper {
  static toSnakeCase(input: string) {
    return input
      .trim()                             // Remove leading/trailing spaces
      .replace(/[^a-zA-Z0-9]+/g, '_')     // Replace all non-alphanumeric characters (including special characters) with underscores
      .replace(/([a-z])([A-Z])/g, '$1_$2')// Insert underscore between camelCase words
      .replace(/_+/g, '_')                // Replace multiple underscores with a single one
      .replace(/^_+|_+$/g, '')            // Remove leading or trailing underscores
      .toLowerCase();
  }

  static toKebabCase(input: string) {
    return input
      .trim()                              // Remove leading/trailing spaces
      .replace(/[^a-zA-Z0-9]+/g, '-')      // Replace all non-alphanumeric characters with hyphens
      .replace(/([a-z])([A-Z])/g, '$1-$2') // Insert hyphen between camelCase words
      .replace(/-+/g, '-')                 // Replace multiple hyphens with a single one
      .replace(/^-+|-+$/g, '')             // Remove leading or trailing hyphens
      .toLowerCase();                      // Convert to lowercase
  }

  static hexToRgba(hex?: string, opacity: number = 1) {
    if (!hex)
      return `rgba(204, 204, 204, 1)`;

    // Remove the '#' if it's present
    let normalizedHex = hex.replace('#', '');

    // If the hex is in shorthand form, e.g. "abc", convert it to "aabbcc"
    if (normalizedHex.length === 3) {
      normalizedHex = normalizedHex.split('').map(ch => ch + ch).join('');
    }

    // Extract the red, green, and blue components
    const r = parseInt(normalizedHex.substring(0, 2), 16);
    const g = parseInt(normalizedHex.substring(2, 4), 16);
    const b = parseInt(normalizedHex.substring(4, 6), 16);

    // Return the rgba string with the specified opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
}
